import { applyMiddleware, createStore } from 'redux'
import logger from 'redux-logger'
import { rootReducer } from './reducers'
import thunk from 'redux-thunk';
import { initApp } from './app/actions';

export const store = createStore(
    rootReducer, 
    applyMiddleware(thunk, logger)
)

store.dispatch(initApp())
